import { render } from "./HomeSso.vue?vue&type=template&id=3388c024&ts=true"
import script from "./HomeSso.vue?vue&type=script&lang=ts"
export * from "./HomeSso.vue?vue&type=script&lang=ts"

import "./HomeSso.vue?vue&type=style&index=0&id=3388c024&lang=css"

import exportComponent from "/home/kanbios/echo-v2/demo-front-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__